export function getEnv(name: string): string | string[] {
  const result: string = (window as any)?.config?.[name] || import.meta.env[name]
  return result
}

export function getEnvArray(key: string): string[] {
  const value = getEnv(key);

  try {
    if (typeof value === "string") {
      return value.split(",").map((item: string) => item.trim());
    }

    return [];
  } catch {
    throw new Error(`Failed to parse environment variable "${key}"`);
  }
}
